<template>
  <v-container>
    <v-card>
      <v-card-title>
        Последние добавленные публикации
        <div class="spacer"></div>
        <div>
          <v-btn class="white--text" icon small @click="fetch">
            <v-icon>refresh</v-icon>
          </v-btn>
        </div>
      </v-card-title>
      <v-card-text>
        <v-data-table
          dense
          loading-text="Загрузка публикаций..."
          :height="600"
          :loading="loading"
          :headers="headers"
          :items="results"
          :items-per-page="20"
          :footer-props="{
            'items-per-page-options': [20, 50, 100],
            'items-per-page-text': 'На странице',
          }"
          @click:row="preview($event)"
        >
          <template v-slot:item.created="{ item }">
            {{ $moment(item.created).format('HH:mm DD/MM/YY') }}
          </template>
          <template v-slot:item.updated="{ item }">
            {{ $moment(item.updated).format('HH:mm:ss DD/MM/YY') }}
          </template>
          <template v-slot:item.publish_date="{ item }">
            {{ $moment(item.publish_date).format('HH:mm:ss DD/MM/YY') }}
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialog" width="800">
      <publication-card v-if="publication" :item="publication" :summary="false" />
      <v-card v-else class="py-6">
        <div style="margin: 0px auto; width: 40px;">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </div>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import PublicationCard from '@/components/publication-card.vue'

export default {
  components: {
    PublicationCard,
  },
  data: () => {
    return {
      loading: false,
      dialog: false,
      results: [],
      publication: null,
      headers: [
        { text: 'Дата', value: 'publish_date', width: 175 },
        {
          text: 'Заголовок',
          align: 'left',
          value: 'title',
          width: 400,
        },
        { text: 'Источник', value: 'source_name', width: 200 },
        { text: 'Создана', value: 'created', width: 175 },
        { text: 'Обновлена', value: 'updated', width: 175 },
      ],
    }
  },
  mounted() {
    this.fetch()
  },
  methods: {
    async fetch() {
      this.loading = true
      try {
        this.results = await this.$axios.$get('publications/')
      } catch (error) {
        this.$toast.fire({
          type: 'error',
          title: 'Ошибка загрузки журнала',
        })
      }

      this.loading = false
    },
    async preview(item) {
      this.publication = null
      this.dialog = true
      this.publication = await this.$axios.$get(`publications/${item.id}/`)
    },
  },
}
</script>

<style scoped>
.v-data-table ::v-deep td {
  cursor: pointer;
}
</style>
